import { makeStyles } from '@fluentui/react';
export const useStyles = makeStyles((theme) => ({
  headerContainer: {
    position: 'sticky',
    top: 0,
    zIndex: 1,
    width: 1500,
  },
  footerContainer: {
    position: 'sticky',
    bottom: 0,
    zIndex: 1,
    width: '100%',
  },
  footerStyle: {
    backgroundColor: theme.palette.neutralLighterAlt,
    boxShadow: `-1px -4px 13px rgba(0, 0, 0, 0.15)`,
  },
}));
